import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useTestsCompleted = () => {
  const [status, setStatus] = useState({ loading: true, fagerstrom: false, motivation: false, prochaska: false });

  useEffect(() => {
    Promise.all(['fagerstrom', 'motivation', 'prochaska'].map((t) => axios.get(`${API_URL}/${t}/latest`)))
      .then(([f, m, p]) => setStatus({ loading: false, fagerstrom: !!f.data, motivation: !!m.data, prochaska: !!p.data }))
      .catch(() => setStatus((s) => ({ ...s, loading: false })));
  }, []);

  return { ...status, allDone: status.fagerstrom && status.motivation && status.prochaska };
};
